import React from 'react';
import { createPortal } from 'react-dom';
import { getReactRendererFromState } from '../extensions';
export const ReactNodeStopEventCn = 'prosemirror-stop-event';
export class ReactNodeView {
    constructor(Component, opts) {
        const { getPos, node, serializer, view, options } = opts;
        this.node = node;
        this.dom = (options === null || options === void 0 ? void 0 : options.isInline)
            ? document.createElement('span')
            : document.createElement('div');
        this.dom.classList.add('react-node-wrapper');
        if (options === null || options === void 0 ? void 0 : options.reactNodeWrapperCn) {
            this.dom.classList.add(options === null || options === void 0 ? void 0 : options.reactNodeWrapperCn);
        }
        this.dom.contentEditable = 'false';
        this.serializer = serializer;
        this.view = view;
        this.getPos = getPos;
        this.renderItem = getReactRendererFromState(view.state).createItem(`${Component.displayName || this.node.type.name}-view`, () => createPortal(React.createElement(Component, { dom: this.dom, view: this.view, updateAttributes: this.updateAttributes.bind(this), node: this.node, getPos: this.getPos.bind(this), serializer: this.serializer, extensionOptions: options === null || options === void 0 ? void 0 : options.extensionOptions }), this.dom));
    }
    update(node) {
        if (node.type !== this.node.type)
            return false;
        if (this.node === node)
            return true;
        this.node = node;
        this.renderItem.rerender();
        return true;
    }
    destroy() {
        this.renderItem.remove();
    }
    ignoreMutation() {
        return true;
    }
    updateAttributes(attributes, marks = []) {
        const pos = this.getPos();
        if (pos === undefined)
            return;
        const { tr } = this.view.state;
        tr.setNodeMarkup(pos, undefined, Object.assign(Object.assign({}, this.node.attrs), attributes), marks);
        this.view.dispatch(tr);
    }
    stopEvent(e) {
        const target = e.target;
        const isInput = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].includes(target.tagName);
        if (isInput ||
            (typeof target.className === 'string' &&
                target.className.includes(ReactNodeStopEventCn))) {
            return true;
        }
        return false;
    }
}
export const reactNodeViewFactory = (Component, options) => ({ serializer }) => (node, view, getPos) => new ReactNodeView(Component, { node, view, getPos, serializer, options });
